import React from 'react';
import { TransferOrderStatus } from 'services/transferOrders/types';
import FBOTag from 'ui/theme/components/FBOTag/FBOTag';
import { colorPalette } from 'ui/theme';
import { colorStatusPaletteMapRestyled } from 'ui/theme/colors/statusColors';

export interface TransferOrderStatusBadgeProps {
  status: TransferOrderStatus;
}

const STATUS_LABEL: Record<TransferOrderStatus, string> = {
  [TransferOrderStatus.Draft]: 'Draft',
  [TransferOrderStatus.Picked]: 'Picked',
  [TransferOrderStatus.InTransit]: 'In Transit',
  [TransferOrderStatus.Received]: 'Received',
  [TransferOrderStatus.Complete]: 'Complete',
  [TransferOrderStatus.PartialTransfer]: 'Partial Transfer',
  [TransferOrderStatus.Cancelled]: 'Cancelled',
};

export const FBOTransferOrderStatusBadge: React.FC<
  TransferOrderStatusBadgeProps
> = ({ status }) => {
  const label = STATUS_LABEL[status];
  const palette =
    colorStatusPaletteMapRestyled[status] ??
    colorPalette.redesign.statusColors.lightGray;

  return (
    <FBOTag
      label={label}
      bgColor={palette.background}
      color={palette.text}
      variant="filled"
      aria-label={label}
      data-qa={`to-status-badge-${status}`}
    />
  );
};

export default FBOTransferOrderStatusBadge;
